export const USER_AUTH = 'USER_AUTH';
export const USER_UNAUTH = 'USER_UNAUTH';
export const AUTH_ERROR = 'AUTH_ERROR';
